import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { ENVIRONMENT_NAMES } from '../const/environmentNames';

export const getEnvironmentName = (request: IRequestContext): string => {
    return request.app.config.environmentName;
};

export const isProduction = (request: IRequestContext): boolean => {
    return getEnvironmentName(request) === ENVIRONMENT_NAMES.PRODUCTION;
};
